import { useContext, useEffect } from "react";
import { RouteContext } from "../../contexts/RoutesContext";
import { JobAlertsUnsubscribeForm } from "../components/Forms/JobAlertsUnsubscribeForm";

export function JobAlertsUnsubscribe() {
    const routeContext = useContext(RouteContext);
    useEffect(() => {
        routeContext.setRoutes([{ name: "Job alerts unsubscribe", route: null }])
    }, []);

    return (
        <>
            <JobAlertsUnsubscribeForm />
        </>
    );
}